<template>
  <div v-if="!isLoading">
    <b-container>
      <div class="mt-4 mb-4 d-flex align-items-start justify-content-between">
        <div>
          <h1 class="page-title">{{ $t('Operations') }} </h1>
          <h2 class="page-subtitle">{{ $t('Total') }} : {{ totalCount }}</h2>
        </div>

        <b-button v-if="allowCreate" variant="primary" @click="clickOnCreateBtn">
          <plus-icon class="mr-1" size="18"/>
          {{ $t('Add') }} {{ $t('a.e') }} {{ $t('operation') }}
        </b-button>
      </div>


      <!-- Empty State -->
      <template v-if="totalCount === 0">
        <div class="empty-state-container">
          <div class="text-center mb-4">
            <img :src="require(`@/assets/images/APRILYOS/empty-table.png`)" alt="no result" class="empty-state-img">
          </div>
          <div class=" text-center no-result-text">
            <div class="no-result-title mb-2">{{ $t('operation.emptyTitle') }}</div>
            <div class="main-color-text-text">{{ $t('operation.emptyText') }}</div>
            <b-button class="my-2" variant="primary" @click="clickOnCreateBtn">
              {{ $t('operation.emptyButton') }}
            </b-button>
          </div>
        </div>
      </template>

      <!-- Opérations -->
      <template v-else>
        <template v-for="operationByStatus in items">

          <div class="mb-2">
            <div v-if="operationByStatus.operations.length !== 0" class="section-title">
              {{ $t(operationByStatus.status.text) }}
            </div>
          </div>

          <div class="mosaic-container row mb-4">
            <template v-for="operation in operationByStatus.operations">
              <div class="col-sm-1 col-md-4 col-lg-4 my-2">
                <b-card class="cursor-pointer" v-on:click="clickOnShowBtn(operation)">
                  <div v-if="operation.picture" class="mb-3  picture-container">
                    <img :src="operation.picture ? getFileUrl(operation.picture.fileUrl) :''" alt=""
                         class="result-img"/>
                  </div>
                  <div v-else class="mb-3 picture-container no-result-container">
                    <img :src="require(`@/assets/images/APRILYOS/emptyState.png`)" alt="No picture" class="no-result-img">
                  </div>

                  <div class="row justify-content-between ml-2 mr-2 px-0">
                    <div style="max-width: 80%;min-width: 150px">
                      <b-link class="main-color-text bold-text level-two-title" v-on:click="clickOnShowBtn(operation)">
                        {{ operation.tostring }}
                      </b-link>
                      <div class="main-color-text"> {{ operation.city }}</div>
                    </div>
                    <div v-if="operation.nbTasks !== 0">
                      <div class="pastille-fail">
                        {{ operation.nbTasks }}
                      </div>
                    </div>
                  </div>

                  <div class="row justify-content-sm-between ml-2 mr-2 px-0">
                    <div class="tertiary-color small-text bold-text my-1">
                      {{ $t('lastModifDate') + ': ' + formatDate(operation.lastModifDate) }}
                    </div>
                    <div v-if="operation.bilanType !== 0 || operation.operationType" class="d-flex ">
                      <span v-if="operation.bilanType" :class="{'bilan-exe':operation.bilanType==='EXE','bilan-avp':operation.bilanType==='AVP'}"
                              class="bilanType-vignette">{{ `Bilan ${operation.bilanType}` }}</span>
                      <span v-if="operation.operationType"
                            class="operationType-vignette">{{ $t(`operation.type.enum.${operation.operationType.toLowerCase()}`) }}</span>
                    </div>
                  </div>
                </b-card>
              </div>
            </template>
          </div>
        </template>
      </template>
    </b-container>
  </div>
</template>

<script>

import i18n from "../../i18n"
import api from "../../services/api";

export default {

  name: 'OperationIndex',

  components: {},

  data() {
    return {
      isCollaborator: this.$store.getters.isCollaborator,
      isCollaboratorPlus: this.$store.getters.isCollaboratorPlus,
      popUp: this.$route.params.popUp,
      isLoading: false,
      totalCount: 0,
      allowCreate: true,
      items: [],
      endFreeAccess: null,
      subscriptionType: null,
      nbOperations: null,
      nbOperationsAnniversary: null,
      currentUserSubscription: null,
      lotLimit: -1,
    }
  },

  async mounted() {
    await this.fetchUserInfos()
    await this.getMaxNbLots()
    await this.fetchItems()
    if (this.popUp) {
      await this.showPopup()
    }
  },


  methods: {

    formatDate(dateString) {
      return new Date(dateString).toLocaleDateString()
    },

    getFileUrl(itemUrl) {
      return process.env.SERVER_URL + itemUrl
    },

    fetchItems() {
      this.isLoading = true
      api
        .get('/operation/getAllAuthorizedOperationsByStatus')
        .then(response => {
          this.items = response.data
          this.items.forEach(operationsByStatus => {
            this.totalCount += operationsByStatus.operations.length
          })
          this.isLoading = false
        })
    },

    async checkIfCanCreateNewOperation() {
      try {
        const response = await api.get('/operation/checkIfCanCreateNewOperation');
        return response.data.canCreate
      } catch (error) {
        return false;
      }
    },

    async showCustomConfirm(message, okText, cancelText) {
      return new Promise((resolve) => {
        this.$bvModal.msgBoxConfirm(message, {
          okTitle: okText,
          cancelTitle: cancelText,
          centered: true,
          okVariant: 'primary',
          cancelVariant: 'secondary',
        })
          .then((confirmed) => {
            resolve(confirmed);
          })
          .catch(() => {
            resolve(false);
          });
      });
    },

    async clickOnCreateBtn() {
      const canCreate = await this.checkIfCanCreateNewOperation();
      if (canCreate) {
        this.$router.push({
          name: 'OperationCreate',
          params: {
            fromSimulation: false,
          },
        });
      } else {
        await this.showPopup()
      }
    },

    async showPopup() {
      var okBtn = this.$i18n.t('SeeSubscription').toString()
      if (this.isCollaborator || this.isCollaboratorPlus) {
        okBtn = this.$i18n.t('Ok')
      }

      let message = "premium.no.more.operation"
      if (this.lotLimit > -1) {
        message = "premium.no.more.operationLot"
      }

      const confirmed = await this.showCustomConfirm(
        this.$i18n.t(message).toString(),
        okBtn,
        this.$i18n.t('Cancel')
      );

      if (confirmed && !this.isCollaborator && !this.isCollaboratorPlus) {
        this.$router.push({name: 'ProfileShow'});
      }
    },

    clickOnShowBtn(item) {
      this.$router.push({
        name: 'OperationShow',
        params: {
          operationId: item.id,
          currentSection: 0
        }
      })
    },

    async fetchUserInfos() {
      await api
        .get(`/user/getUserInfos`)
        .then(async response => {
          this.endFreeAccess = response.data.endFreeAccess
          this.subscriptionType = response.data.subscriptionType
          this.currentUserSubscription = response.data.hasOwnProperty('currentUserSubscription') ? response.data.currentUserSubscription : null
          this.nbOperations = response.data.nbOperations
          this.nbOperationsAnniversary = response.data.nbOperationsAnniversary
        })
    },

    async getMaxNbLots() {
      await api
        .get(`/operationLot/getMaxNbLots`)
        .then(response => {
          this.lotLimit = response.data
        })
    },


  }
}
</script>

<style scoped>

.tertiary-color {
  color: var(--tertiary-text-color);
}

.card-body {
  padding: 0 0 0.5rem;
}

.card {
  border-radius: 0;
  padding: 0;
}


.empty-state-container {
  height: 70%;
  margin-top: 15%;
  margin-bottom: 15%;
}

.empty-state-img {
  max-width: 220px;
}

.no-result-img {
  max-width: 135px;
  max-height: 83px;
}

.picture-container {
  width: 100%;
  height: 125px;
  overflow: hidden;
}

.picture-container .result-img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}


.no-result-title {
  font-family: "Montserrat-Bold", "Arial", sans-serif;
  color: var(--main-color-text);
  font-weight: 400;
}

.bilanType-vignette {
  color: var(--main-white);
  text-align: center;
  font-family: Montserrat, "Arial", sans-serif;
  letter-spacing: 1px;
  border-radius: 4px;
  opacity: 1;
  padding: 4px 8px;
  margin-left: 1em;
  display: flex;
  justify-content: center;
  align-items: center;
  white-space: nowrap;
  font-size: 12px;
}

.operationType-vignette {
  color: var(--main-color-text);
  text-align: center;
  font-family: Montserrat, "Arial", sans-serif;
  letter-spacing: 1px;
  border-radius: 4px;
  opacity: 1;
  padding: 4px 8px;
  margin-left: 1em;
  display: flex;
  justify-content: center;
  align-items: center;
  white-space: nowrap;
  font-size: 12px;
  border: 2px solid var(--main-color);
  background-color: transparent;

}
</style>



// WEBPACK FOOTER //
// src/views/operation/OperationIndex.vue